import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from './core/authentication.service';
import { environment } from '../environments/environment';
import { setupAxiosInterceptors } from './api.interceptor';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'strike-frontend';
  currentAppVersion: string = environment.appVersion;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
  ) { }

  ngOnInit() {
    // Looks for cookie from previous User session. If none is found send user to login page
    // if session found load cookie and continue
    if (!this.authenticationService.loadSavedUserCookie()) {
      this.router.navigate(['/login'])
    }
    setupAxiosInterceptors();
  }
}

